<template>
	<div class="ui-tabbar-wrapper">
		<div class="tabbar-wrapper">
			<ul>
				<li class="item" v-for='item in staticData' v-bind:key="item.key"  v-on:click='setCurrentActive(item)' v-bind:class="{'currentavtive': currentItem == item.link}">
					<img v-bind:src="item.bgurl" v-if='currentItem != item.link'>
					<img v-bind:src="item.activeBgurl" v-if='currentItem == item.link'>
					<span v-if="cartNumber > 0 && item.link == 'cart' && isOnline">{{ getCarCount }}</span>					
					<p v-if="item.name == '我的' && isHasUnreadCount "></p>
					<a>{{item.name}}</a>
				</li>
			</ul>
		</div>
    <mt-popup v-if='subscribeInfo && subscribeInfo.imgurl' :style="{'display':showSubscribeInfo?'block':'none','background-color':'#f3f3f3'}" :visible="showSubscribeInfo" pop-transition="popup-fade">
        <img style="padding:20px;" :src="subscribeInfo.imgurl"  v-if='subscribeInfo && subscribeInfo.imgurl'>
        <div style="text-align: center;padding:10px;" >长按关注公众号</div>
    </mt-popup>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { Header, Indicator, Toast, MessageBox ,Popup  } from 'mint-ui';
import { authSubscribe } from  '../../api/access'
export default {
  data() {
    return {
      staticData: [
        {
          name: '首页',
          link: 'home',
          key: 0,
          bgurl: require('../../assets/image/tabbar-icon/tabbar_home_nor@2x.png'),
          activeBgurl: require('../../assets/image/tabbar-icon/tabbar_home_sel@2x.png'),
          isActive: true
        },
        {
          name: '分类',
          link: 'category',
          key: 1,
          bgurl: require('../../assets/image/tabbar-icon/tabbar_sort_nor@2x.png'),
          activeBgurl: require('../../assets/image/tabbar-icon/tabbar_sort_sel@2x.png'),
          isActive: false
        },
        // {
        //   name: '扫码购',
        //   link: 'scan',
        //   key: 1,
        //   bgurl: require('../../assets/image/tabbar-icon/scan.png'),
        //   activeBgurl: require('../../assets/image/tabbar-icon/scan.png'),
        //   isActive: false
        // },
        {
          name: '购物车',
          link: 'cart',
          params: { type: 1 },
          key: 2,
          bgurl: require('../../assets/image/tabbar-icon/tabbar_cart_nor@2x.png'),
          activeBgurl: require('../../assets/image/tabbar-icon/tabbar_cart_sel@2x.png'),
          isActive: false
        },
        {
          name: '我的',
          link: 'profile',
          key: 3,
          bgurl: require('../../assets/image/tabbar-icon/tabbar_profile_nor@2x.png'),
          activeBgurl: require('../../assets/image/tabbar-icon/tabbar_profile_sel@2x.png'),
          isActive: false
        }
      ],
      follow:{
          name: '关注',
          link: 'follow',
          key: 4,
          bgurl: require('../../assets/image/tabbar-icon/follow_nor.png'),
          activeBgurl: require('../../assets/image/tabbar-icon/follow_sel.png'),
          isActive: false
      },
      subscribeInfo:null,
      showSubscribeInfo:false,
      currentItem: this.$store.state.tabBar.currentTabBar
        ? this.$store.state.tabBar.currentTabBar
        : 'home'
    };
  },
  computed: {
    ...mapState({
      currentTabBar: state => state.tabBar.currentTabBar,
      cartNumber: state => state.tabBar.cartNumber,
      isOnline: state => state.auth.isOnline,
      messageHint: state => state.tabBar.messageHint
    }),
    ...mapGetters({
      isHasUnreadCount: 'isHasUnreadCount'
    }),
    getCarCount() {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return parseInt(this.cartNumber)+"";
      } else if (this.cartNumber >= 100) {
        return '99+';
      }
    }
  },
  created(){
    if(this.wxApi.isweixin() && window.sessionStorage.getItem('subscribe') != 1){
      authSubscribe({}).then(resp=>{
        this.subscribeInfo = resp
        window.sessionStorage.setItem('subscribe',resp.subscribe)
        // this.$cookie.set('subscribe',resp.subscribe)
        if(resp.error_code ==0){
          if(resp.subscribe !=1 && this.staticData.findIndex(item=>item.link=='follow')==-1){
            this.staticData.push(this.follow)
          }
        }
      }).catch(err=>{
        console.dir(err)
      })
    }
  },
  watch: {
    currentTabBar: function(value) {
      let data = this.staticData;
      for (let i = 0; i <= data.length - 1; i++) {
        if (value == data[i].link) {
          this.currentItem = data[i].link;
        }
      }
      if (value !== 'category') {
        this.resetCurrentCategoryItem();
      }
    }
  },

  methods: {
    ...mapMutations({
      resetCurrentCategoryItem: 'resetCurrentCategoryItem'
    }),
    gotoPage(path) {
      this.$router.push(path);
    },
    setCurrentActive(item) {
      if(item.link =='scan'){
        this.scanOver()
      }else if(item.link =='follow'){
        console.dir(this.showSubscribeInfo)
        this.showSubscribeInfo =!this.showSubscribeInfo
      }else{
        this.currentItem = item.link;
        this.$router.push({ name: item.link, query: item.params });
      }
    },
    scanOver(){
      if(isWeixin()){
        window.location.href = 'http://youpinapi.bestegou.com/v2/ecapi.scan.url'
        // let url = 'http://youpinapi.bestegou.com/v2/ecapi.scan.url'
        // this.$router.push({ name: 'webPage', query: {'url': url,'title': '扫码购'}})	
      }else if(window.android){
        window.android.scanOver();
      }else if(typeof window.webkit == 'object'){
        window.webkit.messageHandlers.scanOver.postMessage('');
      }else{
        //h5 的扫一扫
        // if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
        //   Quagga.init({
        //     inputStream : {
        //       name : "Live",
        //       type : "LiveStream",
        //       target: document.querySelector('#yourElement')
        //     },
        //     decoder : {
        //       readers : ["code_128_reader"]
        //     }
        //   }, function(err) {
        //       if (err) {
        //           console.log(err);
        //           Toast(err);
        //           return
        //       }
        //       console.log("Initialization finished. Ready to start");
        //       Quagga.start();
        //       Quagga.onDetected(function(data){
        //         console.log(data)
        //         alert(data.codeResult.code)
        //     })
        //   });
        // }else{
          Toast('该浏览器暂不支持扫一扫!');
        // }
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.ui-tabbar-wrapper {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: auto;
  padding: 0px;
  margin: 0px;
  background-color: #ffffff;
  border-top: 1px solid #f0f2f5;
  z-index:999;
  .tabbar-iron{
    position:absolute;
    left: 0;
    bottom: 50px;
    z-index: 999;
    .img {
      position: relative;
      top:30px;
      left: 16px;
      width: 36px;
      height: auto;
      z-index: 9999;
    }
    .div{
      width: 80px;
      height: 50px;
      background-color: #fa800a;
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
      .p {
        position: relative;
        left: 10px;
        top: 26px;
        font-weight: 550;
      }
    }
  }
  .tabbar-wrapper {
    ul {
      display: flex;
      -webkit-display: flex;
      -moz-display: flex;
      width: auto;
      justify-content: space-around;
      align-content: center;
      align-items: center;
      height: 50px;
      li {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        img {
          @include wh(30px, 30px);
          @include ilc();
          display: $block;
        }
        a {
          @include sc($fontSize, $mainFontColor);
        }
        span {
          position: absolute;
          right: 0px;
          background: #EF3338;
          font-size: 10px;
          color: #ffffff;
          border-radius: 50%;
          width: 14px;
          line-height: 14px;
          height: 14px;
          font-weight: normal;
          text-align: center;
          top: 0px;
          display: inline-block;
        }
        p {
          width: 7px;
          height: 7px;
          position: absolute;
          right: 0px;
          top: 8%;
          background-color: $primaryColor;
          border-radius: 50%;
        }
      }
      li.currentavtive {
        a {
          color: $primaryColor;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/Tabbar.vue